import styled from 'styled-components';

export const Container = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  div.MuiTabs-scrollButtons.Mui-disabled {
    opacity: 0.3;
  }

  button.MuiTab-wrapped {
    min-width: fit-content;
    font-family: 'Sora', sans-serif;
    padding: 6px 16px;
    color: #a6a6a6;
    font-size: 14px;
    text-transform: capitalize;

    &.Mui-selected {
      color: #329bfc;
    }
  }

  span.MuiTabs-indicator {
    background-color: #329bfc;
  }
`;
